import { createFileRoute, notFound } from "@tanstack/react-router";
import { brandConfig } from "@/lib/brandConfig";
import {
  BRAND_PRODUCT_TABLES,
  brandArticlesQueryOptions,
  brandGenericProductsQueryOptions,
  brandProductsQueryOptions,
} from "@/lib/brandLandingQuery";
import BrandLanding from "@/pages/BrandLanding";

export const Route = createFileRoute("/brand/$brandSlug/")({
  beforeLoad: ({ params }) => {
    if (!brandConfig[params.brandSlug]) throw notFound();
  },
  loader: async ({ params, context }) => {
    const qc = context.queryClient;
    await Promise.all([
      qc.ensureQueryData(brandArticlesQueryOptions(params.brandSlug)),
      qc.ensureQueryData(brandGenericProductsQueryOptions(params.brandSlug)),
      ...BRAND_PRODUCT_TABLES.map((t) => qc.ensureQueryData(brandProductsQueryOptions(params.brandSlug, t))),
    ]).catch(() => null);
  },
  head: ({ params }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/brand/${params.brandSlug}`;
    return {
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: BrandLanding,
});
